export enum AuthType {
  Ldap = "ldap",
  Basic = "basic",
  ActiveDirectory = "active-directory",
  Google = "google",
  Auth0 = "auth0",
}
